import { coversEveryTeam } from "app/pages/sales-intelligence/domain/teams/utils/coversEveryTeam";

export const ScoringRuleTeamScope = {
    Account: "account",
    AllTeams: "allTeams",
    SpecificTeams: "specificTeams",
} as const;

export type ScoringRuleTeamScope = (typeof ScoringRuleTeamScope)[keyof typeof ScoringRuleTeamScope];

/**
 * A rule that applies to every team and one where the user ticked every team are the same payload,
 * so the "all teams" option is derived from the selection rather than stored.
 */
export const resolveTeamScope = (
    isAccountScoped: boolean,
    selectedTeamIds: readonly number[],
    allTeamIds: readonly number[],
): ScoringRuleTeamScope => {
    if (isAccountScoped) {
        return ScoringRuleTeamScope.Account;
    }

    return coversEveryTeam(selectedTeamIds, allTeamIds)
        ? ScoringRuleTeamScope.AllTeams
        : ScoringRuleTeamScope.SpecificTeams;
};

/** The selection a scope option produces when the user picks it. */
export const resolveSelectionForScope = (
    scope: ScoringRuleTeamScope,
    currentTeamIds: readonly number[],
    allTeamIds: readonly number[],
): number[] => {
    if (scope === ScoringRuleTeamScope.Account) {
        return [];
    }

    if (scope === ScoringRuleTeamScope.AllTeams) {
        return [...allTeamIds];
    }

    // Keeping a full selection would resolve straight back to "all teams", so picking "specific
    // teams" from there starts the user over.
    return coversEveryTeam(currentTeamIds, allTeamIds) ? [] : [...currentTeamIds];
};
